import { ArrowUpRight, Calendar, Clock, History, Stethoscope } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { PORTAL_ROUTES } from 'utils/constants';
import { formatDate } from 'utils/helpers';
import { LocationLink } from 'components/LocationLink';

export const LastVisitCard = ({ appointment }) => (
  <div className="bg-gray-50 border border-gray-200 rounded-2xl p-4 flex flex-col">
    <div className="flex items-start justify-between mb-2">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-secondary-400">
        <History size={12} />
        Last Visit
      </div>
      {appointment && (
        <LocationLink
          to={`${PORTAL_ROUTES.APPOINTMENTS}/${appointment.id}`}
          aria-label="View appointment details"
          title="View details"
          className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-secondary-900/10 hover:bg-secondary-900/20 text-secondary-600 transition-colors"
        >
          <ArrowUpRight size={14} />
        </LocationLink>
      )}
    </div>

    {appointment ? (
      <>
        <h3 className="flex items-center gap-2 text-base font-bold text-secondary-900 leading-tight">
          <Calendar size={16} className="text-secondary-500" />
          {formatDate(appointment.date, 'short')}
        </h3>

        <div className="grid grid-cols-2 gap-3 mt-3">
          <div className="min-w-0">
            <p className="flex items-center gap-1 text-[10px] font-semibold tracking-wider text-secondary-400 capitalize">
              <Stethoscope size={10} />
              {appointment.provider.role || 'Provider'}
            </p>
            <p className="text-xs font-semibold text-secondary-800 mt-0.5 truncate">
              {appointment.provider.name || 'Not assigned'}
            </p>
          </div>
          <div>
            <p className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-secondary-400">
              <Clock size={10} />
              Time
            </p>
            <p className="text-xs font-semibold text-secondary-800 mt-0.5">
              {appointment.startTime}
            </p>
          </div>
        </div>

        <div className="mt-auto pt-3 border-t border-gray-200 flex items-center justify-between">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-secondary-400">
            Status
          </span>
          <StatusBadge status={appointment.status} />
        </div>
      </>
    ) : (
      <div className="flex flex-col items-center justify-center flex-1 py-3 text-center">
        <div className="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center mb-1.5">
          <History size={14} className="text-secondary-400" />
        </div>
        <p className="text-xs font-semibold text-secondary-700">No past visits yet</p>
      </div>
    )}
  </div>
);
